import styled from 'styled-components';
import { noop } from 'utils/noop';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Popover, PopoverTrigger, PopoverContent } from 'ui/popover';
import { WhatsApp } from 'constants/messageMediums';
import { useQueryParams } from 'utils/hooks/useQueryParams';
import { Add16 } from 'ui/icons';
import { InputSearch } from 'ui/inputs';
import { H4, spacing, WebLink } from 'ui/theme';
import { getMediumByKey } from 'utils/messageMediums';
import { useChannelModalsContext, useSearchContext, useChannelsContext } from '../contexts';

export const Container = styled.div`
  display: flex;
  gap: ${spacing.base};
  flex-wrap: wrap;
  align-items: center;

  & > div:first-of-type {
    flex-grow: 1;
  }
`;

export const SectionHeading = styled(H4)`
  flex-grow: 2;
  margin-bottom: 0;
`;

export const HEADER_TEXT = {
  buttonLabel: 'New subscription channel',
  searchInputId: 'channels-search-input',
  searchInputPlaceholder: 'Search all channels and types',
};

type Props = {
  headingText: string | undefined;
};

export const ChannelsHeader = ({ headingText }: Props) => {
  const { messageMedium, espAccounts } = useChannelsContext();
  const { showCreateChannelModal } = useChannelModalsContext();
  const query = useQueryParams();
  const showWhatsAppAddChannel = query.get('showWhatsAppAddChannel');
  const { inputValue, setInputValue } = useSearchContext();
  const mediumByKey = getMediumByKey(messageMedium);

  return (
    <Container>
      <SectionHeading>{headingText}</SectionHeading>
      <InputSearch
        data-test={HEADER_TEXT.searchInputId}
        id={HEADER_TEXT.searchInputId}
        onChange={setInputValue}
        placeholder={HEADER_TEXT.searchInputPlaceholder}
        value={inputValue}
      />
      {mediumByKey?.messageType === WhatsApp &&
      espAccounts?.length < 1 &&
      !showWhatsAppAddChannel ? (
        <Popover>
          <PopoverContent>
            <div>Set up your WhatsApp sending platform to create a subscription channel</div>
            <WebLink href="/settings/sendingPlatforms">Set up sending platform</WebLink>
          </PopoverContent>
          <PopoverTrigger asChild>
            <PrimaryButton data-test="add-channel-btn" onClick={noop} size={BUTTON_SIZES.LARGE}>
              <Add16 />
              <span>{HEADER_TEXT.buttonLabel}</span>
            </PrimaryButton>
          </PopoverTrigger>
        </Popover>
      ) : (
        <PrimaryButton
          data-test="add-channel-btn"
          onClick={showCreateChannelModal}
          size={BUTTON_SIZES.LARGE}
        >
          <Add16 />
          <span>{HEADER_TEXT.buttonLabel}</span>
        </PrimaryButton>
      )}
    </Container>
  );
};
